import { ActionReducerMap} from '@ngrx/store';
import { State } from './core.state';
import * as ContextReducer from './context/context.reducer';

export const reducers: ActionReducerMap<State> = {
  context: ContextReducer.reducer
};